export default __webpack_public_path__ + "static/media/utility4.21b80022.jpg";